import { InfraredFlight } from "@nova/protobuf"
import { selectInfraredImagesAndUploadsByFlightId } from "features/entity-caching/images/hotspots/selectors"
import { selectActivatedFireId } from "features/map/control/selectors"
import { takeMapSnapshot } from "features/map/module"
import { zoomToShowFlightPath, zoomToShowHotspotsInFlightPath } from "features/map/zoom/thunks"
import store from "integrations/redux/store"
import { activateBaseHotspotLayers } from "panels/content/side-panel/thunks"

export const zoomToHotspots = (entity: InfraredFlight) => {
    const state = store.getState()
    const dispatch = store.dispatch
    const uploads = selectInfraredImagesAndUploadsByFlightId(entity.id)(state)
    if (uploads && uploads.length > 0) {
        dispatch(zoomToShowFlightPath(uploads))
    } else if (entity.skippedProcessing)
        dispatch(zoomToShowHotspotsInFlightPath({ flightId: entity.id }))
    dispatch(activateBaseHotspotLayers({ flightId: entity.id }))
    const projectId = selectActivatedFireId(state)!

    //we need to revisit when and how snapshots are being taken
    //updateMostRecentJobId()
    takeMapSnapshot(projectId)
}

export const shouldHideHotspotInspectorPanel = (entity: InfraredFlight) => {
    const state = store.getState()
    const uploads = selectInfraredImagesAndUploadsByFlightId(entity.id)(state)
    if (entity.skippedProcessing && !(entity.hotspots.length > 0)) return true
    return (!uploads || uploads.length === 0) && !entity.skippedProcessing
}
